<script>
import { Bar } from 'vue-chartjs'
export default {
    props: ['chartData'],
    extends: Bar,
    data() {
        return {
            options: {
                scales: {
                    indexAxis: 'y',
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: true
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    watch: {
        chartData: {
            handler() {
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }
    }
}
</script>